var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrisonGuard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.83073C10.3859 5.41212 9.00087 5.16406 7.5 5.16406C5.99915 5.16406 4.61415 5.41212 3.5 5.83073",
    stroke: "#414E5D",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14773 5.83594L3.66141 4.89425C3.27554 4.14708 3.08261 3.77349 3.20411 3.44329C3.32563 3.1131 3.69953 2.99489 4.44735 2.75848L7.09447 1.92163C7.27513 1.8645 7.36553 1.83594 7.4582 1.83594C7.55093 1.83594 7.64133 1.8645 7.822 1.92163L10.6473 2.81482C11.321 3.02778 11.6578 3.13426 11.7862 3.43318C11.9147 3.7321 11.7767 4.08834 11.5007 4.80083L11.0998 5.83594",
    stroke: "#414E5D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 5.83594V6.98605C4.16797 8.18154 4.7823 9.2894 5.78632 9.90447L6.12932 10.1146C6.97377 10.6319 8.02883 10.6319 8.8733 10.1146L9.2163 9.90447C10.2203 9.2894 10.8346 8.18154 10.8346 6.98605V5.83594",
    stroke: "#414E5D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4987 9.83594L10.1654 11.8359M10.1654 11.8359L9.25283 12.6329C8.4169 13.3629 7.99896 13.7279 7.4987 13.7279C6.99843 13.7279 6.5805 13.3629 5.74459 12.6329L4.83203 11.8359M10.1654 11.8359L11.3214 12.2213C11.9868 12.4431 12.3195 12.554 12.6148 12.7254C12.904 12.8932 13.1662 13.1035 13.3927 13.3493C13.6241 13.6005 14.1654 14.5026 14.1654 15.1693M4.83203 11.8359L5.4987 9.83594M4.83203 11.8359L3.67594 12.2213C3.01056 12.4431 2.67788 12.554 2.38254 12.7254C2.09345 12.8932 1.83124 13.1035 1.60472 13.3493C1.3733 13.6005 0.832031 14.5026 0.832031 15.1693",
    stroke: "#414E5D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrisonGuard);
export default __webpack_public_path__ + "static/media/prison-guard.1cc1b3259867412d958813c70c10aef8.svg";
export { ForwardRef as ReactComponent };